import React from 'react';
import styles from './RelatedRequestBody.module.scss';
import moment from 'moment';
import getName from '../../../../../../../helpers/getName';
import { Tooltip } from 'antd';

const RelatedRequestBody = ({ request }) => {
  return (
    <div className={styles.root}>
      <div className={styles.flexBox}>
        <Tooltip title="Дата создания">
          <span className={styles.text}>
            {moment(request.createDateTime).format('DD.MM.YYYY hh:mm')}
          </span>
        </Tooltip>
        <Tooltip title="Статус">
          <div className={styles.box}>{request?.status}</div>
        </Tooltip>
      </div>
      <div className={styles.flexBox}>
        <Tooltip title="Создатель">
          <span
            style={{ whiteSpace: 'nowrap' }}
            className={styles.text}
          >
            {getName(request.createUser) || ''}
          </span>
        </Tooltip>
        {request?.stageAddressLifeCycle?.id && (
          <Tooltip title="Стадия помещения при создании заявки">
            <div className={styles.box}>
              {request?.stageAddressLifeCycle?.name}
            </div>
          </Tooltip>
        )}
      </div>
      <div className={styles.leftCol}>
        {request.parentService && (
          <div className={styles.text}>
            <span className={styles.accent}>Услуга: </span>
            {request.parentService}
          </div>
        )}
        {request.service && (
          <div className={styles.text}>
            <span className={styles.accent}>Причина: </span> {request.service}
          </div>
        )}
      </div>
      {request.executeDateTime && (
        <div className={styles.rightCol}>
          <div className={styles.text}>
            <span className={styles.accent}>Дата назначения: </span>
            <span>
              {moment(request.executeDateTime).format('DD.MM.YYYY hh:mm')}
            </span>
          </div>
        </div>
      )}
      {request.doneDateTime && (
        <div className={styles.rightCol}>
          <div className={styles.text}>
            <span className={styles.accent}>Дата выполнения: </span>
            <span>
              {moment(request.doneDateTime).format('DD.MM.YYYY hh:mm')}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default RelatedRequestBody;
